module.exports = __webpack_public_path__ + "img/yl3028.88950835.png";